<template>
  <el-row>
    <el-col :span="24">

      <el-col :span="24" style="height:62px;line-height:62px;">

        <el-col :span="10">

          <el-button
            style="margin-left:10px;"
            icon="el-icon-plus"
            type="primary"
            @click="addchejian"
          >新增隧道</el-button>
        </el-col>
      </el-col>
      <el-col
        :span="24"
        style="background:rgba(0,217,255,.15);padding:10px;margin-top: 10px; "
      >
        <el-row>

          <el-col :span="24">

            <el-table
              :data="chejiandata"
              style="width: 100%"
              border
            >
              <el-table-column
                fixed
                prop="name"
                label="隧道名称"
                min-width="150"
              >
              </el-table-column>
              <el-table-column
                fixed
                prop="sort"
                label="排序"
                min-width="150"
              >
              </el-table-column>

              <el-table-column
                label="操作"
                min-width="200"
              >
                <template slot-scope="scope">
                  <el-button
                    @click="editdepbtn(scope.row)"
                    type="warning"
                    size="small"
                  >编辑</el-button>
                  <el-button
                    @click="deldepbtn(scope.row)"
                    type="danger"
                    size="small"
                  >删除</el-button>
                </template>
              </el-table-column>
            </el-table>

          </el-col>

        </el-row>

      </el-col>
    </el-col>

    <el-dialog
      title=""
      :visible.sync="dialogchejianVisible"
      width="30%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      :show-close="false"
    >
      <el-row style="    margin-top: -40px;">
        <el-col
          :span="24"
          class="stoptitle"
        >
          {{editchejian.id?'编辑隧道':'新增隧道'}}
        </el-col>
        <el-col
          :span="24"
          style="margin-top:10px"
        >
          <el-form
            :model="editchejian"
            :rules="chejianRules"
            ref="chejianForm"
            label-width="100px"
          >

            <el-form-item
              label="隧道名称"
              prop="chejianname"
            >
              <el-input v-model="editchejian.chejianname"></el-input>
            </el-form-item>
            <el-form-item
              label="排序"
              prop="sort"
            >
              <el-input
                type="number"
                v-model="editchejian.sort"
              ></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogchejianVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitForm('chejianForm')"
        >确 定</el-button>
      </span>
    </el-dialog>
  </el-row>
</template>

<script>
import { getalldep, editdep, deldep } from "../../api/api";
export default {
  data() {
    return {
      chejiandata: [],
      editchejian: {
        chejianname: "",
        id: 0,
        sort: 0
      },
      chejianRules: {
        chejianname: [
          { required: true, message: "请输入隧道名称", trigger: "blur" },
          { min: 1, max: 10, message: "长度在 3 到 10 个字符", trigger: "blur" }
        ]
      },
      dialogchejianVisible: false
    };
  },
  created() {
    this.getalldeplist();
  },
  methods: {
    submitForm(formName) {
      let that = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (formName == "chejianForm") {
            editdep({
              chejianname: that.editchejian.chejianname,
              id: that.editchejian.id,
              sort: that.editchejian.sort
            }).then(res => {
              if (res.state == 0) {
                this.$message({
                  message: "编辑隧道成功",
                  type: "success"
                });
                that.dialogchejianVisible = false;
                that.getalldeplist();
              } else {
                this.$message({
                  message: res.msg,
                  type: "error"
                });
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    addchejian() {
      this.editchejian.chejianname = "";
      this.editchejian.id = 0;
      this.editchejian.sort = 0;
      this.dialogchejianVisible = true;
    },
    getalldeplist() {
      let that = this;

      getalldep().then(res => {
        if (res.state == 0) {
          that.chejiandata = res.data;
        } else {
        }
      });
    },

    editdepbtn(row) {
      (this.editchejian.chejianname = row.name),
        (this.editchejian.id = row.id),
        (this.editchejian.sort = row.sort);

      this.dialogchejianVisible = true;
    },

    deldepbtn(row) {
      let that = this;

      this.$confirm("此操作将永久删除该隧道, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deldep({ id: row.id }).then(res => {
            if (res.state == 0) {
              this.$message({
                message: "删除隧道成功",
                type: "success"
              });
              that.getalldeplist();
            } else {
              this.$message({
                message: res.msg,
                type: "error"
              });
            }
          });
          that.getalldeplist();
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped>
</style>